import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#000000',
                secondary: '#ffffff',
                accent: '#F5002F',
                error: '#f88080',
                info: '#6fbcf9',
                success: '#72ab74',
                warning: '#f7d05c',
            },
        },
    },
    icons: {
        iconfont: 'fa',
    },
});
